import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default (function () {
  return /*#__PURE__*/_jsxs("g", {
    children: [/*#__PURE__*/_jsx("rect", {
      className: "line",
      x: "5.578",
      y: "15",
      width: "21.125",
      height: "2"
    }), /*#__PURE__*/_jsx("polygon", {
      className: "line",
      points: "12.977,25.095 3.882,16 12.977,6.905 14.391,8.319 6.71,16 14.391,23.681"
    })]
  });
});